<!-- Content Area -->
<div class="p-8">
    <div class="flex justify-between items-center mb-6">
        <h1 class="text-xl lg:text-3xl font-bold text-gray-900">Order List</h1>
        <button
            (click)="openAddModal()"
            class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 text-base lg:text-sm font-semibold rounded-lg transition flex items-center gap-2"
        >
            <span>+</span>
            <span>Add Order</span>
        </button>
    </div>

    <!-- Table -->
    <div class="bg-white rounded-lg shadow-sm mb-6">
        <div class="overflow-x-auto">
            <table class="w-full">
                <thead>
                    <tr class="border-b border-gray-200">
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            No
                        </th>
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Customer Name
                        </th>
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Phone
                        </th>
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Address
                        </th>
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Total Products
                        </th>
                        <th
                            class="text-center py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100">
                    <tr
                        *ngFor="let order of Order; let i = index"
                        class="hover:bg-gray-50 transition-colors"
                    >
                        <td class="py-4 px-6 text-sm text-gray-900">
                            {{ (pagination.current_page - 1) * pagination.per_page + i + 1 }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-900">
                            {{ order.name }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            {{ order.phone }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            {{ order.address }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            {{ getTotalProducts(order) }} items
                        </td>
                        <td class="py-4 px-6">
                            <div class="flex items-center justify-center gap-0">
                                <button
                                    (click)="openEditModal(order.id)"
                                    class="text-gray-600 hover:text-gray-900 transition-colors border border-[#D5D5D5] py-2 px-3 rounded-l-lg hover:bg-gray-50 flex items-center gap-1 whitespace-nowrap"
                                >
                                    <img
                                        src="assets/visidea/icon/pencil-write.png"
                                        class="w-4 h-4 flex-shrink-0"
                                        alt="Edit"
                                    />
                                </button>
                                <button
                                    (click)="deleteOrder(order.id, order.name)"
                                    class="text-red-500 hover:text-red-700 transition-colors border border-[#D5D5D5] py-2 px-3 rounded-r-lg hover:bg-red-50 flex items-center gap-1 whitespace-nowrap"
                                >
                                    <img
                                        src="assets/visidea/icon/bin.png"
                                        class="w-4 h-4 flex-shrink-0"
                                        alt="Delete"
                                    />
                                </button>
                            </div>
                        </td>
                    </tr>

                    <!-- Empty State -->
                    <tr *ngIf="Order.length === 0">
                        <td colspan="6" class="py-8 text-center text-gray-500">
                            Tidak ada data order
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div
            class="flex items-center justify-between px-6 py-4 border-t border-gray-200"
        >
            <button
                (click)="previousPage()"
                [disabled]="pagination.current_page === 1"
                class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <img
                    src="assets/visidea/icon/left.png"
                    class="w-[12px] h-[12px]"
                    alt=""
                />
                <span>Previous</span>
            </button>

            <span class="text-sm text-gray-600">
                Page {{ pagination.current_page }} of {{ pagination.last_page }}
            </span>

            <button
                (click)="nextPage()"
                [disabled]="pagination.current_page === pagination.last_page"
                class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <span>Next</span>
                <img
                    src="assets/visidea/icon/right.png"
                    class="w-[12px] h-[12px]"
                    alt=""
                />
            </button>
        </div>
    </div>
</div>

<!-- Modal Add/Edit Order -->
<div
    *ngIf="isModalOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto"
    (click)="closeModal()"
>
    <div
        class="bg-white rounded-lg shadow-xl max-w-3xl w-full p-6 my-8 animate-fadeIn"
        (click)="$event.stopPropagation()"
    >
        <div class="flex justify-between items-center mb-6">
            <h2 class="text-2xl font-bold text-gray-900">
                {{ isEditMode ? "Edit Order" : "Add New Order" }}
            </h2>
            <button
                (click)="closeModal()"
                class="text-gray-400 hover:text-gray-600 text-2xl"
            >
                &times;
            </button>
        </div>

        <form (ngSubmit)="onSubmit()" #orderFormElement="ngForm">
            <!-- Customer Information Section -->
            <div class="mb-6">
                <h3 class="text-lg font-semibold text-gray-800 mb-4 border-b pb-2">
                    Customer Information
                </h3>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <!-- Name -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                            Name <span class="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            [(ngModel)]="orderForm.name"
                            name="name"
                            required
                            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter customer name"
                        />
                    </div>

                    <!-- Phone -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                            Phone <span class="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            [(ngModel)]="orderForm.phone"
                            name="phone"
                            required
                            maxlength="13"
                            pattern="^08\d{8,11}$"
                            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="08xxxxxxxxxx (max 13 chars)"
                        />
                        <p class="text-xs text-gray-500 mt-1">Format: 08xxxxxxxxxx (max 13 karakter)</p>
                    </div>

                    <!-- Email -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                            Email <span class="text-gray-400">(Optional)</span>
                        </label>
                        <input
                            type="email"
                            [(ngModel)]="orderForm.email"
                            name="email"
                            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="customer@email.com"
                        />
                    </div>

                    <!-- Address -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                            Address <span class="text-red-500">*</span>
                        </label>
                        <textarea
                            [(ngModel)]="orderForm.address"
                            name="address"
                            required
                            rows="3"
                            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter customer address"
                        ></textarea>
                    </div>
                </div>
            </div>

            <!-- Products Section -->
            <div class="mb-6">
                <div class="flex justify-between items-center mb-4 border-b pb-2">
                    <h3 class="text-lg font-semibold text-gray-800">
                        Products <span class="text-red-500">*</span>
                    </h3>
                    <button
                        type="button"
                        (click)="addProductRow()"
                        class="bg-green-500 hover:bg-green-600 text-white py-1 px-3 rounded text-sm transition"
                    >
                        + Add Product
                    </button>
                </div>

                <div class="space-y-3">
                    <div
                        *ngFor="let product of orderForm.products; let i = index"
                        class="flex gap-3 items-start bg-gray-50 p-3 rounded-lg"
                    >
                        <div class="flex-1">
                            <label class="block text-xs font-medium text-gray-600 mb-1">
                                Product
                            </label>
                            <select
                                [(ngModel)]="product.id"
                                [name]="'product_id_' + i"
                                required
                                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                            >
                                <option value="">Select Product</option>
                                <option *ngFor="let p of Products" [value]="p.id">
                                    {{ p.name }} - Rp {{ p.price | number }}
                                </option>
                            </select>
                        </div>

                        <div class="w-24">
                            <label class="block text-xs font-medium text-gray-600 mb-1">
                                Qty
                            </label>
                            <input
                                type="number"
                                [(ngModel)]="product.quantity"
                                [name]="'quantity_' + i"
                                required
                                min="1"
                                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                            />
                        </div>

                        <div class="w-32">
                            <label class="block text-xs font-medium text-gray-600 mb-1">
                                Subtotal
                            </label>
                            <div class="px-3 py-2 bg-gray-100 rounded-lg text-sm text-gray-700">
                                Rp {{ calculateSubtotal(product.id, product.quantity) | number }}
                            </div>
                        </div>

                        <div class="pt-6">
                            <button
                                type="button"
                                (click)="removeProductRow(i)"
                                class="text-red-500 hover:text-red-700 transition-colors p-2"
                                [disabled]="orderForm.products.length === 1"
                            >
                                <img
                                    src="assets/visidea/icon/bin.png"
                                    class="w-[16px] h-[16px]"
                                    alt="Remove"
                                />
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Total -->
                <div class="mt-4 flex justify-end">
                    <div class="bg-blue-50 px-4 py-3 rounded-lg">
                        <span class="text-sm font-medium text-gray-700">Total: </span>
                        <span class="text-lg font-bold text-blue-600">
                            Rp {{ calculateTotal() | number }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Optional Fields Section -->
            <div class="mb-6">
                <h3 class="text-lg font-semibold text-gray-800 mb-4 border-b pb-2">
                    Optional Information
                </h3>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <!-- Location ID -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                            Location ID <span class="text-gray-400">(Optional)</span>
                        </label>
                        <input
                            type="text"
                            [(ngModel)]="orderForm.location_id"
                            name="location_id"
                            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter location ID"
                        />
                    </div>

                    <!-- Voucher ID -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
                            Voucher ID <span class="text-gray-400">(Optional)</span>
                        </label>
                        <input
                            type="text"
                            [(ngModel)]="orderForm.voucher_id"
                            name="voucher_id"
                            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter voucher ID"
                        />
                    </div>
                </div>
            </div>

            <!-- Buttons -->
            <div class="flex gap-3 pt-4 border-t">
                <button
                    type="button"
                    (click)="closeModal()"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition disabled:opacity-50"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <span *ngIf="!isSubmitting">
                        {{ isEditMode ? "Update Order" : "Create Order" }}
                    </span>
                    <span *ngIf="isSubmitting">Processing...</span>
                </button>
            </div>
        </form>
    </div>
</div>
